import { render, staticRenderFns } from "./ProjectWizard.vue?vue&type=template&id=6973b17a"
import script from "./ProjectWizard.vue?vue&type=script&lang=js"
export * from "./ProjectWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports